import type * as React from 'react';

import { LoadingIndicator } from './LoadingIndicator';
import { PanelChrome as PanelChromeComponent, type PanelChromeProps } from './PanelChrome';
import { TitleItem } from './TitleItem';

/**
 * @internal
 */
export type { PanelChromeProps, PanelPadding } from './PanelChrome';

/**
 * @internal
 */
export interface PanelChromeType extends React.FC<PanelChromeProps> {
  LoadingIndicator: typeof LoadingIndicator;
  TitleItem: typeof TitleItem;
}

/**
 * @internal
 */
export const PanelChrome = PanelChromeComponent as PanelChromeType;
PanelChrome.LoadingIndicator = LoadingIndicator;
PanelChrome.TitleItem = TitleItem;

/**
 * Exporting the components for extensibility and since it is a good practice
 * according to the api-extractor.
 */
export {
  LoadingIndicator as PanelChromeLoadingIndicator,
  type LoadingIndicatorProps as PanelChromeLoadingIndicatorProps,
} from './LoadingIndicator';

export {
  usePanelContext,
  PanelContextProvider,
  type PanelContext,
  type PanelRuntimeTransformations,
  type AdHocTransformationsState,
  PanelContextRoot,
} from './PanelContext';
export { useAdHocTransformations } from './useAdHocTransformations';

export * from './types';
export { usePanelNotices, usePanelStatusSnapshot } from './usePanelNotices';
export { PanelStatusActions } from './PanelStatusActions';
